type BreakpointType = 'base' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';

const breakpoints: { [key in BreakpointType]: number } = {
	'3xl': 1680,
	'2xl': 1480,
	xl: 1280,
	lg: 1080,
	md: 880,
	sm: 680,
	xs: 480,
	base: 0,
};

const screens = {
	'3xl': { max: `${breakpoints['3xl']}px` },
	'2xl': { max: `${breakpoints['2xl']}px` },
	xl: { max: `${breakpoints.xl}px` },
	lg: { max: `${breakpoints.lg}px` },
	md: { max: `${breakpoints.md}px` },
	sm: { max: `${breakpoints.sm}px` },
	xs: { max: `${breakpoints.xs}px` },
};

type ScreensType = typeof screens;
export { screens, breakpoints, type ScreensType, type BreakpointType };
